export default function buildLangUrl(path) {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get('lang');
  if (lang) {
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}lang=${lang}`;
  }
  return path;
}
